export default "/_next/static/images/service-drop-ins-desktop-3x-197f56e2ba287476ac80c1918d4ae3c8.jpg";